import React, { useEffect, useState } from 'react';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios, {source} from '../../../httpClients/axios-datamerch'
import {authHeaders} from '../../../helpers'

import { CircularProgress, Backdrop, Card, CardContent, Grid, Typography, Avatar } from '@mui/material';
import MoneyIcon from '@mui/icons-material/Money';
import { NumericFormat } from 'react-number-format'
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  avatar: {
    backgroundColor: theme.palette.success.main,
    height: 56,
    width: 56
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  }
});

const TotalMonthlyRevenue = props => {
  const classes = useClasses(styles);
  const [loading, setLoading] = useState(true)
  const [kpiValue, setKpiValue] = useState(0)
  
  useEffect(() => {
    setLoading(true)
    let url = `/widgets/total_monthly_revenue`
    let config = authHeaders()
    axios.get(url, config)
    .then(response => {
      if (response){
        setLoading(false)
        // setKpiValue((response.data.data-1) * 695)
        setKpiValue((response.data.data))
      }
      else {
        setLoading(false)
      }
    })
    .catch(error => {
      setLoading(false)
    })
    
    return () => {
      source.cancel()
    }
  }, [])

  let kpi = (
    <CircularProgress color="inherit" />
  )
  if(!loading){
    kpi = (
      <Card>
        <CardContent>
          <Grid
            container
            justifyContent="space-between"
          >
            <Grid>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
                variant="body2"
              >
                PROJECTED MONTHLY REVENUE
              </Typography>
              <Typography variant="h3"><NumericFormat value={kpiValue} displayType={'text'} thousandSeparator={true} prefix={'$'} /></Typography>
            </Grid>
            <Grid>
              <Avatar sx={{
                  backgroundColor: "#43a047",
                  height: 56,
                  width: 56
                }}>
                <MoneyIcon className={classes.icon} />
              </Avatar>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
  }
  
  return (
    <React.Fragment>
      {kpi}
    </React.Fragment>
  );
};

export default withErrorHandler(TotalMonthlyRevenue, axios)